var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Page p404"},[_c('div',{staticClass:"p404__text"},[_vm._v("\n    "+_vm._s(_vm.trans('text'))+" 404\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }